import { CrmIntegrationType } from '@alucio/aws-beacon-amplify/src/models';

export const getCrmRecordUrl = (
  instanceUrl: string,
  crmCallId: string,
  crmIntegrationType?: CrmIntegrationType | keyof typeof CrmIntegrationType,
): string => {
  const isVeevaVault = crmIntegrationType === CrmIntegrationType.VEEVA_VAULT;
  return isVeevaVault
    ? `${instanceUrl}/ui/#app/page/call-report/~/view?id=${crmCallId}`
    : `${instanceUrl}/${crmCallId}`;
};
